import { createApp, ref } from 'vue'
import Buefy from './vue/buefy'
import BaseIndex from './vue/BaseIndex.vue'
import i18n from './vue/i18n'

import '../scss/base_index.scss'

class Index {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[CC+ index online]')

      const app = document.querySelector('#vue-index')
      if (app) {
        this.app = createApp(BaseIndex)
        this.app.provide('api', app.dataset)

        Buefy(this.app)
        this.app.use(i18n)
        this.app.mount('#vue-index')
      }
    })
  }
}

export default new Index()
